import { useEffect, useState } from "react";
import Label from "../Label/Label";
import styles from "./Input.module.scss";
import Icons from "../../../assets/icons";

export const inputType = {
  email: "email",
  password: "password",
  text: "text",
  number: "number",
  tel: "tel",
  file: "file",
};
const Input = ({
  variant,
  placeholder,
  searchBar,
  value,
  handleInput,
  name,
  required,
  error,
  disabled,
  onBlur,
  onFocus,
  onKeyPress,
  selectSearch,
  reference,
  onKeyDown,
  borderError,
  noMargin,
  autoComplete,
  darkBorder,
  onWheel,
  autoFocus,
  step,
}) => {
  const [isValue, setIsValue] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  useEffect(() => {
    if (value === null || value === "" || value === undefined) {
      setIsValue(false);
    } else {
      setIsValue(true);
    }
  }, [value]);

  const [isFocus, setIsFocus] = useState(false);

  const handleFocus = () => {
    setIsFocus(true);
    if (onFocus) {
      onFocus();
    }
  };

  const handleBlur = () => {
    setIsFocus(false);
    if (onBlur) {
      onBlur();
    }
  };
  return (
    <Label
      searchBar={searchBar}
      isFocus={isFocus}
      isValue={isValue}
      required={required}
      selectSearch={selectSearch}
      placeholder={placeholder}
      error={error}
      disabled={disabled}
      htmlFor={styles.input}
      noMargin={noMargin}
    >
      <input
        className={`${styles.input} ${error || borderError ? styles.input__error : ""} ${disabled ? styles.input__disabled : ""}`}
        data-dark-border={darkBorder}
        ref={reference}
        type={isPasswordVisible ? inputType.text : inputType[variant]}
        name={name}
        onKeyDown={onKeyDown}
        disabled={disabled}
        value={value}
        step={step}
        onKeyPress={onKeyPress}
        autoComplete={autoComplete}
        onChange={(e) => {
          handleInput && handleInput(e);
        }}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onWheel={onWheel && onWheel}
        autoFocus={autoFocus}
      />
      {variant === inputType.password && (
        <button className={styles.passwordReveal} onClick={() => setIsPasswordVisible(!isPasswordVisible)}>{isPasswordVisible ? Icons.passwordHide : Icons.passwordReveal}</button>
      )}
    </Label>
  );
};

export default Input;
